/* 
ALL RIGHTS RESERVED. The content of this document is protected by copyright and constitutes trade secrets.  
The content hereof may also be protected by patents, trademarks, design rights and other intellectual property rights. 
The rights contained herein are owned or licensed by Temperature Sensitive Solutions Systems Sweden AB,  
reg. no. 556278-0816, Sweden, ("TSS"), and may not be used, licensed, assigned, transferred, reproduced, copied,  
disclosed, disseminated, modified or amended in any way not expressly and specifically granted by TSS in writing. 
TSS and TSS' suppliers reserves any and all rights not expressly granted to you in writing, including the right to take  
any and all actions deemed appropriate to safeguard its rights in and to the content of this document. 
*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { injectIntl } from 'react-intl';
import {
  Table,
  FilterControls,
  Paginator,
} from 'tss-core-lib-components';

let styles;

class ContactInfoListPage extends Component {
  static propTypes = {
    contacts: PropTypes.arrayOf(
      PropTypes.shape( {
        id: PropTypes.number,
        number: PropTypes.oneOfType( [ PropTypes.number, PropTypes.string ] ).isRequired,
        country: PropTypes.string,
      } ),
    ).isRequired,
    searchQuery: PropTypes.string.isRequired,
    pageNr: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    onSearchQueryChange: PropTypes.func.isRequired,
    onPageChange: PropTypes.func.isRequired,
  };

  state = {};


  userToTableRowData = ( contact ) => ( {
    id: contact.id,
    data: [
      contact.country,
      contact.number,
      contact.comment,
    ],
  } );
  render() {
    const columns = [
      {
        id: 'COUNTRY',
        labelKey: 'module.public.contact.list.header.country',
        sortable: false,
      },
      {
        id: 'NUMBER',
        labelKey: 'module.public.contact.list.header.number',
        sortable: false,
      },
    ];
    return (
      <div>
        <div className={ css( styles.header ) }>
          <div className={ css( styles.heading ) } />
          <div className={ css( styles.filterControlsContainer ) }>
            <FilterControls
              searchQuery={ this.props.searchQuery }
              onSearchChange={ this.props.onSearchQueryChange }
            />
          </div>
        </div>
        <Table
          columns={ columns }
          data={ this.props.contacts
            .map( ( contact ) =>
              this.userToTableRowData(
                contact,
              ),
            )
          }
          focusRowStyle={ styles.recentData }
        />
        <div className={ css( styles.paginatorContainer ) }>
          <Paginator
            totalPages={ this.props.totalPages }
            currentPage={ this.props.pageNr }
            onChange={ this.props.onPageChange }
          />
        </div>
      </div>
    );
  }
}

styles = StyleSheet.create( {
  header: {
    margin: '2.4rem 3rem 0 2.3rem',
    display: 'flex',
    alignItems: 'center',
  },

  heading: {
    flex: '1 1 50%',
    margin: '0.6rem 0 2rem 0',
    height: '4.3rem',
  },

  filterControlsContainer: {},

  filtersSummaryContainer: {
    margin: '0 2.3rem',
  },

  paginatorContainer: {
    margin: '2rem 0',
    display: 'flex',
    justifyContent: 'center',
  },
} );

export default injectIntl( ContactInfoListPage );



// WEBPACK FOOTER //
// ./src/pages/ContactInfoListPage.js